module.exports = __webpack_public_path__ + "static/media/consulting-data-table-image-left.468a7250.png";